// extracted by mini-css-extract-plugin
module.exports = {"PriceItem":"PriceTable_PriceItem__6o0sC","subTitle":"PriceTable_subTitle__bv7PB","oldPrice":"PriceTable_oldPrice__vpXUP"};